import { Link } from 'react-router-dom';

export const PasswordInput = ({ password, setPassword, validateLoginForm }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) {
      return;
    }
    validateLoginForm();
  };

  return (
    <form className="login-container" onSubmit={handleSubmit}>
      <div className="password-container relative-container">
        <input
          type="password"
          id="password"
          name="password"
          className="contact-form-input"
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          required
        />
        <label htmlFor="password" className="contact-form-label">
          Mot de passe
        </label>
      </div>
      <Link to="/forgot-password" className="login-forgot-password">
        Mot de passe oublié
      </Link>
      <button type="submit" className="btn-create-account">
        Connexion
      </button>
    </form>
  );
};
